<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="form-group">
        <label class="text-black-50"><small>File formats: jpg, jpeg, png</small></label>
        <input
          type="file"
          class="form-control-file"
          :required="isRequired"
          v-on:change="actionFileUpload($event)"
          accept=".jpg,.jpeg,.png"
          multiple>
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please complete this field
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass'
  ],
  data () {
    return {
      fileContent: ''
    }
  },
  methods: {
    actionFileUpload: function (upload) {
      if (upload.srcElement.files[0].name) {
        const fileInput = upload.target
        console.log(' actionFileUpload called ', upload.srcElement.files[0].name, fileInput)
        const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
        if (!allowedExtensions.exec(upload.srcElement.files[0].name)) {
            alert('Invalid file type. Only .jpg, .jpeg, and .png files are allowed.')
            fileInput.value = ''; // Clear the file input
            this.$emit('addedFileinputContent', {label: this.label, content: '', validated: true, displayField: this.displayField})
            return false
        }
      }
      console.log(' inside content ', upload.target.files)
      this.$emit('addedFileinputContent', {label: this.label, content: upload.target.files, validated: true, displayField: this.displayField})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldImageInput.vue